import { useEffect } from 'react'
import ReactGA from 'react-ga4'

const useGoogleAnalytics = (accountAnalyticsCode?: string | null) => {
  // const { data: account, isLoading } = useAccountData()

  useEffect(() => {
    if (accountAnalyticsCode) {
      ReactGA.initialize(accountAnalyticsCode)
    }
  }, [accountAnalyticsCode])
}

export default useGoogleAnalytics
